<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">客户名：</span>
      <el-input size="mini" v-model="search.SupplyName" placeholder="填写客户名称搜索" class="etms-router-search-element el-width-200 fl"></el-input>
      <span class="etms-router-search-label fl">分类：</span>
      <el-select size="mini" placeholder="选择客户分类搜索" v-model="search.CustomerTypeId" class="etms-router-search-element el-width-200 fl">
        <el-option v-for="item in constant.customerTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-tooltip class="item" effect="dark" content="添加" placement="top">
        <el-button size="mini" @click="insertClick" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询" placement="top">
        <el-button size="mini" @click="searchClick" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-table :data="search.customerlist" :border="true" height="90%" class="etms-router-list">
      <el-table-column label="序号" type="index" align="center"></el-table-column>
      <el-table-column label="分类" align="center" width="80px">
        <template slot-scope="scope">{{scope.row.CustomerOwnedEnterpriseId===''?'自建客户':'平台客户'}}</template>
      </el-table-column>
      <el-table-column label="客户" align="center">
        <template slot-scope="scope">{{scope.row.CustomerName + '['+scope.row.CustomerCode+']'}}</template>
      </el-table-column>
      <el-table-column label="揽件地区">
        <template slot-scope="scope">{{regionmodule.regionEach(scope.row.CustomerRegion, regionmodule.regions, 0)}} {{scope.row.CustomerAddress}}</template>
      </el-table-column>
      <el-table-column label="联系电话">
        <template slot-scope="scope">
          {{scope.row.CustomerMobile}}/{{scope.row.CustomerPhone}}
        </template>
      </el-table-column>
      <el-table-column label="余额" prop="CustomerBalance" align="center" width="100px"></el-table-column>
      <el-table-column label="信用额度" prop="CustomerCreditLine" align="center" width="100px"></el-table-column>
      <el-table-column label="状态" prop="State" width="100px" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-tooltip class="item" content="修改" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="editClick(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="删除" placement="top">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteClick(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogInsert.dialogtitle" :visible.sync="dialogInsert.dialogvisible" :modal-append-to-body="false" center>
      <el-form :model="dialogInsert.form" :rules="dialogInsert.form.rules" :ref="dialogInsert.form.formname" label-width="120px" class="el-form-half etms-dialog-form">
        <el-form-item label="客户分类：" prop="CustomerType">
          <el-select size="mini" placeholder="请选择客户分类" v-model="dialogInsert.form.CustomerType" class="el-width-200">
            <el-option v-for="item in constant.customerTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台企业：" v-show="dialogInsert.form.CustomerType === 0" prop="OwnedEnterprise">
          <el-select size="mini" placeholder="请选择平台企业" v-model="dialogInsert.form.CustomerOwnedEnterpriseId" class="el-width-200">
            <el-option v-for="item in dialogInsert.form.enterpriselist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户代码：" prop="CustomerCode">
          <el-input size="mini" placeholder="请填写客户代码" v-model="dialogInsert.form.CustomerCode" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="客户名：" prop="CustomerName">
          <el-input size="mini" placeholder="请填写客户名" v-model="dialogInsert.form.CustomerName" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="信用额度：">
          <el-input size="mini" type="number" placeholder="请填写客户信用额度" v-model="dialogInsert.form.CustomerCreditLine" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="归属业务：" prop="BindSaleman">
          <el-select size="mini" placeholder="请选择归属业务" v-model="dialogInsert.form.BindSaleman" class="el-width-200">
            <el-option v-for="item in dialogInsert.form.enterpriseaccountlist.filter(item=>item.SalemanState === true)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属客服：" prop="BindService">
          <el-select size="mini" placeholder="请选择归属客服" v-model="dialogInsert.form.BindService" class="el-width-200">
            <el-option v-for="item in dialogInsert.form.enterpriseaccountlist.filter(item=>item.ServiceState===true)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属财务：" prop="BindFinance">
          <el-select size="mini" placeholder="请选择归属财务" v-model="dialogInsert.form.BindFinance" class="el-width-200">
            <el-option v-for="item in dialogInsert.form.enterpriseaccountlist.filter(item=>item.FinanceState == true)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人性别：">
          <el-select size="mini" v-model="dialogInsert.form.CustomerSex" class="el-width-100">
            <el-option v-for="item in constant.sexs" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码：" prop="CustomerMobile">
          <el-input size="mini" placeholder="请填写手机号码" v-model="dialogInsert.form.CustomerMobile" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input size="mini" placeholder="请填写联系电话" v-model="dialogInsert.form.CustomerPhone" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input size="mini" placeholder="请填写邮箱" v-model="dialogInsert.form.CustomerEmail" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="QQ：">
          <el-input size="mini" placeholder="请填写QQ" v-model="dialogInsert.form.CustomerQQ" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="微信：">
          <el-input size="mini" placeholder="请填写微信" v-model="dialogInsert.form.CustomerWechat" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="揽件地区：" prop="CustomerRegion">
          <el-cascader size="mini" placeholder="请选择揽件地区" :options="regionmodule.regions" v-model="dialogInsert.form.CustomerRegion" filterable class="el-width-200"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" prop="CustomerAddress">
          <el-input size="mini" placeholder="请填写详细地址" v-model="dialogInsert.form.CustomerAddress" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="允许重量误差：">
          <el-input-number size="mini" v-model="dialogInsert.form.AllowWeightError" class="el-width-100"></el-input-number>g
        </el-form-item>
        <el-form-item label="允许长度误差：">
          <el-input-number size="mini" v-model="dialogInsert.form.AllowLongError" class="el-width-100"></el-input-number>cm
        </el-form-item>
        <div class="clear"></div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogInsertSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    var ownedEnterpriseValidate = (rule, value, callback) => {
      if (this.dialogInsert.form.CustomerType === 0 && (value === null || value === undefined || value === '')) {
        callback(new Error('请选择平台企业'))
      }
      callback()
    }
    return {
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        CustomerName: '',
        CustomerTypeId: '',
        customerlist: [
          {
            CustomerId: '',
            CustomerOwnedEnterpriseId: '',
            CustomerCode: 'GZKMS',
            CustomerName: '康美森',
            CustomerBalance: '5000',
            CustomerCreditLine: '50000',
            CustomerOutboundAmount: '15000',
            BindSaleman: '',
            BindService: '',
            BindFinance: '',
            CustomerSex: '',
            CustomerMobile: '15000000000',
            CustomerPhone: '020-12142521',
            CustomerFax: '',
            CustomerEmail: '1234566@qq.com',
            CustomerQQ: '12351212',
            CustomerWechat: '15000001551',
            CustomerRegion: ['440000', '440100', '440111'],
            CustomerAddress: '嘉禾街望岗上胜东街46号上胜创意园K栋101',
            AllowWeightError: '',
            AllowLongError: '',
            State: '',
          }
        ],
      },
      dialogInsert: {
        dialogtitle: '添加客户',
        dialogvisible: false,
        form: {
          rules: {
            CustomerType: [
              { required: true, message: '请选择客户分类', trigger: 'change' },
            ],
            OwnedEnterprise: [
              { validator: ownedEnterpriseValidate, trigger: 'change' }
            ],
            CustomerCode: [
              { required: true, message: '请填写客户代码', trigger: 'blur' },
              { min: 2, max: 10, message: '长度在2到 10 个字符', trigger: 'blur' },
            ],
            CustomerName: [
              { required: true, message: '请填写客户名称', trigger: 'blur' },
              { min: 2, max: 10, message: '长度在2到 20 个字符', trigger: 'blur' },
            ],
            BindSaleman: [
              { required: true, message: '请选择客户归属业务员', trigger: 'change' },
            ],
            BindService: [
              { required: true, message: '请选择客户归属客服', trigger: 'change' },
            ],
            BindFinance: [
              { required: true, message: '请选择客户归属财务', trigger: 'change' },
            ],
            CustomerMobile: [
              { required: true, message: '请选择客户联系手机号码', trigger: 'blur' },
            ],
            CustomerRegion: [
              { required: true, message: '请选择揽件地区', trigger: 'change' },
            ],
            CustomerAddress: [
              { required: true, message: '请填写客户详细地址', trigger: 'blur' },
            ]
          },
          formname: 'insertform',
          enterpriselist: [
            { label: '广州腾汇', value: '0000' }
          ],
          enterpriseaccountlist: [
            { value: '0', label: '黄志刚', SalemanState: true, ServiceState: true, FinanceState: false },
            { value: '1', label: '焦志强', SalemanState: true, ServiceState: true, FinanceState: true },
            { value: '2', label: '肖湘南', SalemanState: true, ServiceState: true, FinanceState: true },
          ],
          CustomerId: '',
          CustomerType: '',
          enterpriseshow: '',
          CustomerOwnedEnterpriseId: '',
          CustomerCode: '',
          CustomerName: '',
          CustomerCreditLine: 0,
          BindSaleman: '',
          BindService: '',
          BindFinance: '',
          CustomerSex: '',
          CustomerMobile: '',
          CustomerPhone: '',
          CustomerEmail: '',
          CustomerQQ: '',
          CustomerWechat: '',
          CustomerRegion: [],
          CustomerAddress: '',
          AllowWeightError: '',
          AllowLongError: '',
        },
      }
    }
  },
  methods: {
    insertClick () {
      this.dialogInsert.dialogtitle = '添加客户'
      this.dialogInsert.dialogvisible = true
    },
    searchClick () { },
    handleSizeChange (val) { },
    handleCurrentChange (val) { },
    editClick (row) {
      this.dialogInsert.dialogtitle = '修改客户信息'
      this.dialogInsert.dialogvisible = true
    },
    deleteClick (row) {
      this.$confirm('删除后数据将不可恢复,是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$message({ type: 'success', message: '删除成功' })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    dialogInsertSave () {
      this.$refs[this.dialogInsert.form.formname].validate((valid) => {
        if (valid) {

        }
      })
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/customer_manage.vue